import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-not-found" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "uppercase" }, "FORE!", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "uppercase" }, "The page is most likely lost.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_router_link, {
      to: "/",
      class: "button cta-button transition",
      title: "Play a provisional"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Play a provisional")
      ]),
      _: 1
    })
  ]))
}